var _path, _path2, _path3, _polygon, _path4, _polygon2, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialBio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b69449d1-5d1b-47ef-955d-97dc06911a02",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 602,
    height: 535.28379,
    viewBox: "0 0 602 535.28379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.51124,612.2258l-18.30162-11.659a273.13465,273.13465,0,0,1-.78666-30.77636l9.49369,2.42554-9.37047-5.96941c.51751-12.68956,1.6637-21.06011,1.6637-21.06011s37.0035,24.0357,60.60336,56.615L425.78893,629.355l9.5974-19.269a110.5054,110.5054,0,0,1,6.60266,12.21685c19.44421,42.47823,21.33357,83.26415,4.22,91.09776s-46.74947-20.2514-66.19366-62.72969c-6.02791-13.16868-9.35521-28.30973-11.07932-42.93537Z",
    transform: "translate(-299 -182.3581)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348.91768,653.2272l-21.69358-.52051a273.14027,273.14027,0,0,1-16.58178-25.93933l9.38079-2.831-11.10711-.2665c-6.11625-11.13035-9.4618-18.88836-9.4618-18.88836s44.10074,1.44846,81.14355,17.139l10.79752,25.66731-1.7444-21.45606a110.5067,110.5067,0,0,1,11.96707,7.04529c38.60219,26.31258,61.30188,60.25048,50.70108,75.80244s-50.48761,6.82874-89.08981-19.48381c-11.96706-8.15716-22.64181-19.39868-31.67775-31.0277Z",
    transform: "translate(-299 -182.3581)",
    fill: "#f0f0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M658.10181,332.61314l-17-2-6,52L619.783,454.42107a10.99719,10.99719,0,1,0,11.93262,1.50476l15.38623-42.31269Z",
    transform: "translate(-299 -182.3581)",
    fill: "#ffb6b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "383.797 520.968 369.791 520.968 363.127 466.943 383.799 466.944 383.797 520.968",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M686.36886,716.90332l-45.16217-.00167v-.57123a17.57932,17.57932,0,0,1,17.57838-17.5781h.00111l27.58351.00112Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "491.287 513.329 477.535 515.984 460.747 464.204 481.044 460.285 491.287 513.329",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M796.36936,708.34005l-44.34288,8.56327-.10833-.56086a17.57931,17.57931,0,0,1,13.92571-20.59279l.00109-.00022,27.08314-5.23006Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M660.83551,247.3967l8.13824,15.61361,60.95076-13.44341-6.67694-30.27241c-5.285-23.96168-26.47247-41.26679-50.43367-35.98186s-35.14214,28.70523-29.85711,52.66691l9.82192,30.60278,9.9376-2.19185Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M639.10188,419.61315s-6,30,2,74,10,63,10,63-6,7-2,11,0,12,0,12l9,97,31-5-4-91s4-8,2-10,2-14,2-14l5-95,31,104s-3,4,0,7,9,18,9,18l20,70,32-6-18-80s2-5-1-8a7.83339,7.83339,0,0,1-2-7s3-3-1-7-6-20-6-20-3-107-13-113S639.10188,419.61315,639.10188,419.61315Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 385.31831,
    cy: 43.79395,
    r: 28,
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M723.77814,261.99379s20.32374-2.38064,26.32374,3.61936l-6,121s4,3,2,10a28.5687,28.5687,0,0,0,0,14s6,7,3,10-111,1-111,1-4-7,2-11,3-15,3-15-2-3,3-8,9-46,9-46l-13-50S655.188,276.84261,670.145,275.72792Z",
    transform: "translate(-299 -182.3581)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M657.59449,292.30131l-15.49261-.68816s-9,18-10,34l-5.50739,59.68816,35.50739,5.31184Z",
    transform: "translate(-299 -182.3581)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M660.32984,227.54057l-10.40161-13.38183a10.91076,10.91076,0,0,1,8.28222-12.96924l39.29224-8.66651a10.91174,10.91174,0,0,1,12.97,8.28223l.02149.09668-2.81372,16.15918-.49414-.08838c-24.38477-4.34766-31.33106-2.81836-46.45923,10.22559Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M764.97657,441.35338l-1.87476-78.74024-2-56-24,3,12.88892,133.84577a11,11,0,1,0,14.98584-2.10553Z",
    transform: "translate(-299 -182.3581)",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M732.59449,267.30131l17.50739-1.68816s3,0,6,10,19.49261,115.68816,19.49261,115.68816l-36.49261,3.31184Z",
    transform: "translate(-299 -182.3581)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M623.82249,392.24245h-2.3399V328.14168a37.09977,37.09977,0,0,0-37.09974-37.09982H448.57661a37.09977,37.09977,0,0,0-37.09985,37.0997V679.8035a37.09979,37.09979,0,0,0,37.09975,37.09982H584.38267a37.0998,37.0998,0,0,0,37.09989-37.09967V437.87048h2.33993Z",
    transform: "translate(-299 -182.3581)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M585.87969,300.69395h-17.7272a13.16291,13.16291,0,0,1-12.18706,18.13419H478.1638a13.16291,13.16291,0,0,1-12.18707-18.13422H449.41948a27.70571,27.70571,0,0,0-27.70572,27.70567V679.54553a27.70571,27.70571,0,0,0,27.70569,27.70573H585.87969a27.70571,27.70571,0,0,0,27.70573-27.70569h0V328.39962A27.70568,27.70568,0,0,0,585.87969,300.69395Z",
    transform: "translate(-299 -182.3581)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M495.74379,428.30825l3.7733,13.07091,48.2194-.85068-.4225-23.94912c-.33443-18.95658-13.73167-35.30622-32.68787-34.9718s-31.00948,16.36026-30.67506,35.31684l2.7538,24.68079,7.86184-.1387Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.78089,
    cy: 233.4553,
    r: 21.63483,
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M559.84449,449.55193l-.49024,9.1a57.9288,57.9288,0,0,1-80.28955,3.11c-.5-.44-.99023-.9-1.47021-1.37,3-2.98,11.28027-10.34,20.47021-11.02l41.43994-2.61005S555.20435,444.92193,559.84449,449.55193Z",
    transform: "translate(-299 -182.3581)",
    fill: "#e4e4e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M540.46461,400.62194a8.39116,8.39116,0,0,0-1.49024-4.63c-.09961-.14-.19971-.27-.2998-.4a8.43088,8.43088,0,0,0-6.76026-3.23l-15.5498.28-15.54.27a8.41955,8.41955,0,0,0-8.25,8.55l3.70019,7.45,2.12989,4.28.35009-.2c13.44971-7.56,18.94971-7.66,36.75-.63l.35987.14,1.41015-3.61,3.19971-8.19Z",
    transform: "translate(-299 -182.3581)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M563.34449,454.06194a58.61855,58.61855,0,0,1-16.06006,14.18l-.96973-17.38,13.52979-1.31S561.46461,449.55193,563.34449,454.06194Z",
    transform: "translate(-299 -182.3581)",
    fill: "#e4e4e4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M517.59449,477.41192a58.81825,58.81825,0,0,1-39.19385-14.90235c-.50977-.44824-1.01318-.92041-1.50586-1.40332a58.39859,58.39859,0,0,1-18.30029-42.69433,59,59,0,0,1,118,0,58.36548,58.36548,0,0,1-12.46192,36.26562,58.95633,58.95633,0,0,1-46.53808,22.73438Zm0-116a57.06468,57.06468,0,0,0-57,57,56.42575,56.42575,0,0,0,17.68921,41.25537c.47778.46777.95483.91552,1.44165,1.34375a57.06813,57.06813,0,0,0,82.83105-7.56494,56.38,56.38,0,0,0,12.03809-35.03418A57.06468,57.06468,0,0,0,517.59449,361.41192Z",
    transform: "translate(-299 -182.3581)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M570.634,559.20946H466.69555a7.89209,7.89209,0,1,1,0-15.78418H570.634a7.89209,7.89209,0,1,1,0,15.78418Z",
    transform: "translate(-299 -182.3581)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M570.634,584.20946H466.69555a7.89209,7.89209,0,1,1,0-15.78418H570.634a7.89209,7.89209,0,1,1,0,15.78418Z",
    transform: "translate(-299 -182.3581)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3313,533.90575h-53.332a7.89209,7.89209,0,1,1,0-15.78418h53.332a7.89209,7.89209,0,0,1,0,15.78418Z",
    transform: "translate(-299 -182.3581)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M900,717.6419H300a1,1,0,0,1,0-2H900a1,1,0,0,1,0,2Z",
    transform: "translate(-299 -182.3581)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialBio);
export default __webpack_public_path__ + "static/media/social_bio.6849257c2310b59f04fec8a989937762.svg";
export { ForwardRef as ReactComponent };